import byFeatureGroup from './byFeatureGroup';

const namespaced = true;

export const getters = {
  appliedFilters: (state, gttrs) => {
    return Object.keys(state)
      .map(key => {
        const { name } = state[key];
        const value = gttrs[`${key}/readableValue`];

        return { name, value };
      })
      .filter(filter => filter.value);
  },
};

export default {
  namespaced,
  state: {},
  getters,
  modules: {
    byFeatureGroup,
  },
};
